import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

interface LegalSection {
  id: string;
  title: string;
  content: string[];
}
@Component({
  selector: 'app-mentions-legales',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './mentions-legales.html',
  styleUrl: './mentions-legales.scss'
})
export class MentionsLegales {
  lastUpdate = '1er mars 2026';

  sections: LegalSection[] = [
    {
      id: 'editeur',
      title: 'Éditeur du site',
      content: [
        'Le site Referio est édité par la société <strong>Referio SPRL</strong>',
        'Siège social : Rue de l\'exemple 123, 1000 Bruxelles, Belgique',
        'N° d\'entreprise : BE0123456789',
        'Email : <a href="mailto:contact@referio.be">contact@referio.be</a>',
        'Téléphone : +32 423 45 67 89',
      ]
    },
    {
      id: 'hebergement',
      title: 'Hébergement',
      content: [
        'Le site est hébergé par :<br><strong>OVHcloud</strong>',
        '2 rue Kellermann, 59100 Roubaix, France',
        'Téléphone : +33 9 72 10 10 07',
        'Site web : <a href="https://www.ovhcloud.com" target="_blank" rel="noopener">www.ovhcloud.com</a>'
      ]
    },
    {
      id: 'propriete',
      title: 'Propriété intellectuelle',
      content: [
        'L\'ensemble des éléments constituant le site Referio (textes, graphiques, logiciels, photographies, images, sons, plans, noms, logos, marques, créations et œuvres protégeables diverses, bases de données…) sont la propriété exclusive de Referio SPRL ou font l\'objet d\'une autorisation d\'utilisation.',
        'Ces éléments sont protégés par les lois françaises et internationales relatives à la propriété intellectuelle.',
        'Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie de ces éléments, y compris les applications informatiques, sans l\'accord préalable et écrit de Referio SPRL, est strictement interdite.',
        'Le fait pour Referio SPRL de ne pas engager de procédure dès la prise de connaissance de ces utilisations non autorisées ne vaut pas acceptation desdites utilisations et renonciation aux poursuites.'
      ]
    },
    {
      id: 'donnees',
      title: 'Données personnelles',
      content: [
        'Referio SPRL s\'engage à protéger la vie privée des utilisateurs du site conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés.',
        'Les données personnelles collectées sur ce site sont traitées dans le respect de la vie privée des utilisateurs. Pour toute information sur la gestion de vos données personnelles, veuillez consulter notre <a routerLink="/politique-confidentialite">Politique de confidentialité</a>.',
        'Vous disposez d\'un droit d\'accès, de rectification, d\'effacement, de portabilité et d\'opposition concernant vos données personnelles. Pour exercer ces droits, contactez-nous à : <a href="mailto:contact@referio.be">contact@referio.be</a>',
        'Conformément à la réglementation en vigueur, vous avez également la possibilité d\'introduire une réclamation auprès de la CNIL (Commission Nationale de l\'Informatique et des Libertés).'
      ]
    },
    {
      id: 'cookies',
      title: 'Cookies',
      content: [
        'Le site Referio utilise des cookies afin d\'améliorer votre expérience de navigation. Un cookie est un petit fichier texte stocké sur votre terminal lors de votre visite.',
        'Nous utilisons des cookies techniques (nécessaires au fonctionnement du site), des cookies analytiques (mesure d\'audience via des outils anonymisés) et des cookies de préférences (mémorisation de vos choix).',
        'Vous pouvez configurer votre navigateur pour refuser les cookies ou être alerté lorsqu\'un cookie est envoyé. Cependant, certaines fonctionnalités du site pourraient ne pas fonctionner correctement si vous désactivez les cookies.',
        'Pour plus d\'informations sur la gestion des cookies, consultez notre <a routerLink="/politique-confidentialite">Politique de confidentialité</a>.'
      ]
    },
    {
      id: 'responsabilite',
      title: 'Limitation de responsabilité',
      content: [
        'Referio SPRL s\'efforce de fournir sur le site des informations aussi précises que possible. Toutefois, elle ne pourra être tenue responsable des omissions, des inexactitudes et des carences dans la mise à jour, qu\'elles soient de son fait ou du fait des tiers partenaires qui lui fournissent ces informations.',
        'Les informations présentes sur le site sont données à titre indicatif et sont susceptibles d\'évoluer. Par ailleurs, les renseignements figurant sur le site ne sont pas exhaustifs.',
        'Referio SPRL ne saurait être tenu pour responsable des dommages directs ou indirects résultant de l\'utilisation du site ou d\'autres sites qui lui sont liés.'
      ]
    },
    {
      id: 'droit',
      title: 'Droit applicable et juridiction',
      content: [
        'Les présentes mentions légales sont soumises au droit français.',
        'En cas de litige, et après l\'échec de toute tentative de recherche d\'une solution amiable, les tribunaux français seront seuls compétents pour connaître de ce litige.',
        'Pour toute question relative aux présentes mentions légales, vous pouvez nous contacter à l\'adresse : <a href="mailto:contact@referio.be">contact@referio.be</a>'
      ]
    }
  ];

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

}
